import * as React from "react";
import { styled } from "@mui/material";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const base = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 109,
	height: 113,
	fill: "none",
	viewBox: "0 0 109 113",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "#9B7447",
			d: "M31.5 19.8C15.4 29.9 29 52.4 40.8 54.2c.7.1 1 1 .3 1.3-5.2 2.6-17 6.5-17.7 15.8-.7 10.1 13.6 6.4 20.7 2.8a.8.8 0 0 1 1.2.7c-.1 11 4.5 27 16 27 8.3 0 9-12 8.1-20-.1-1.3 1.2-2.2 2.3-1.6 15.4 7.6 22 2.7 23.5-.9 4.2-7.5-9.8-19-18.3-24.4a.8.8 0 0 1 0-1.3c5-2.7 12-9 7.3-16.4-4.4-7-16.2-.6-22.8 4.1-.6.4-1.6-.3-1.5-1 2.8-13.5-12.4-30.6-28.4-20.5Z"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 2.7,
			cy: 2.7,
			r: 2.7,
			fill: "#BA1B0D",
			transform: "rotate(-32.2 123.6 -62.7) skewX(.5)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 2.7,
			cy: 2.7,
			r: 2.7,
			fill: "#BA1B0D",
			transform: "rotate(-32.2 139.1 -67.3) skewX(.5)"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "#fff",
			strokeLinecap: "round",
			strokeWidth: 2.4,
			d: "M43.6 41.7c1.9 1.3 6.4.7 5.3-3.4"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 1.8,
			cy: 1.8,
			r: 1.8,
			fill: "#fff",
			transform: "matrix(1 -.025 .025 1 36.1 33.8)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 1.8,
			cy: 1.8,
			r: 1.8,
			fill: "#fff",
			transform: "matrix(1 -.025 .025 1 43.3 28.2)"
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "mask0_12036_14972",
			width: 73,
			height: 84,
			x: 23,
			y: 18,
			maskUnits: "userSpaceOnUse",
			style: { maskType: "alpha" },
			children: /* @__PURE__ */ _jsx("path", {
				fill: "#382A1A",
				d: "M32.2 21.3c-16.7 10.5.8 26 10 32.5.4.3.4.8 0 1-4.4 2.7-18 6.4-18.8 16.5-.8 10.1 13.6 6.4 20.7 2.8a.8.8 0 0 1 1.1.7c0 11 4.6 27 16 27 8.4 0 9-12 8.2-20-.1-1.3 1.2-2.2 2.3-1.6 15.3 7.6 22 2.7 23.4-.9 4.2-7.5-9.7-19-18.2-24.4a.8.8 0 0 1 0-1.3c5-2.7 12-9 7.3-16.4-4.8-7.4-18 .4-24.2 5.2-.4.3-1 0-1.2-.5-2.2-11-10.1-31-26.6-20.6Z"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			mask: "url(#mask0_12036_14972)",
			children: /* @__PURE__ */ _jsx("path", {
				fill: "#715739",
				fillOpacity: .5,
				d: "M71.3 98.5C38 97.9 67.7 80 28 57.2c-31 27.7-1 36.4 13.4 54.6 20.4-5.6 63.4-12.7 30-13.3Z"
			})
		})
	]
});
const SvgGingerbreadMan = styled(base)({});
export default SvgGingerbreadMan;
